// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"MJ-z","carouselContainer":"NJ-z"};